<mat-form-field [ngClass]="{ 'opacity-50': disabled }">
  <mat-select
    [(value)]="selectedOption"
    class="bg-white !rounded-full border-none"
    (selectionChange)="onSelectionChange($event.value)"
    [disabled]="disabled"
  >
    @for (option of optionList; track option.value) {
      <mat-option [value]="option.value">
        {{ option.viewValue }}
      </mat-option>
    }
  </mat-select>
</mat-form-field>
